import React from 'react';
import { Link } from 'react-router-dom';
import { MapPin, Phone, Mail, Facebook, Instagram } from 'lucide-react';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <Link to="/" className="footer-logo font-display">
              JMJ.
            </Link>
            <p className="footer-tagline">
              We Craft Your Dream Interior!
            </p>
            <p className="footer-description">
              Kerala's expert interior designer with years of experience crafting 
              some of the finest interior decoration projects.
            </p>
          </div>

          <div className="footer-section">
            <h3>Quick Links</h3>
            <div className="footer-links">
              <Link to="/">Home</Link>
              <Link to="/about">About</Link>
              <Link to="/services">Services</Link>
              <Link to="/gallery">Gallery</Link>
              <Link to="/contact">Contact</Link>
            </div>
          </div>

          <div className="footer-section">
            <h3>Our Services</h3>
            <div className="footer-links">
              <span>Interior Design</span>
              <span>Furniture Design</span>
              <span>Modular Kitchen</span>
              <span>Home Renovation</span>
              <span>Commercial Interiors</span>
            </div>
          </div>

          <div className="footer-section">
            <h3>Contact Info</h3>
            <div className="contact-info">
              <div className="contact-item">
                <MapPin size={18} />
                <div>
                  <p>Kurumkanny RPS Buildings</p>
                  <p>Panacheppally P.O, Kanjirappally</p>
                </div>
              </div>
              <div className="contact-item">
                <Phone size={18} />
                <span>+91 9947222426</span>
              </div>
              <div className="contact-item">
                <Mail size={18} />
                <span>jmjinteriorkerala@gmail.com</span>
              </div>
            </div>
            
            <div className="social-links">
              <a href="https://www.facebook.com/jmj.interiors.374" target="_blank" rel="noopener noreferrer">
                <Facebook size={20} />
              </a>
              <a href="https://www.instagram.com/jmj_interiors/" target="_blank" rel="noopener noreferrer">
                <Instagram size={20} />
              </a>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <p>&copy; 2024 JMJ Furniture and Interior. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;